/* Derived view-model for the design route.
 * GENERATED from the original artifact's vals_design() by
 * tools/convert-logic.py; edits since generation are tracked in git. */
import { FOOTER_COLS } from '@/data/wft';
import { setTheme } from '@/lib/theme-store';

export function designVals() {
  return {
    footerCols: FOOTER_COLS,
    setTerminal: () => setTheme('terminal'),
    setCanon: () => setTheme('canon'),
    swatches: [
      { name: '--wft-bg-0', value: 'var(--wft-bg-0)', use: 'page' },
      { name: '--wft-bg-1', value: 'var(--wft-bg-1)', use: 'panel' },
      { name: '--wft-bg-2', value: 'var(--wft-bg-2)', use: 'raised / hover' },
      { name: '--wft-bg-sunk', value: 'var(--wft-bg-sunk)', use: 'chrome' },
      { name: '--wft-ink-0', value: 'var(--wft-ink-0)', use: 'values' },
      { name: '--wft-ink-1', value: 'var(--wft-ink-1)', use: 'secondary' },
      { name: '--wft-ink-2', value: 'var(--wft-ink-2)', use: 'labels' },
      { name: '--wft-ink-3', value: 'var(--wft-ink-3)', use: 'axis ticks' },
      { name: '--wft-up', value: 'var(--wft-up)', use: 'delta up' },
      { name: '--wft-down', value: 'var(--wft-down)', use: 'delta down' },
      { name: '--wft-flat', value: 'var(--wft-flat)', use: 'below precision' },
      { name: '--wft-accent', value: 'var(--wft-accent)', use: 'attention' },
      { name: '--wft-engine', value: 'var(--wft-engine)', use: 'forecast ink' },
      { name: '--wft-baseline', value: 'var(--wft-baseline)', use: 'baseline' },
      { name: '--wft-scenario', value: 'var(--wft-scenario)', use: 'branch paths' },
      { name: '--wft-unbound', value: 'var(--wft-unbound)', use: 'no connector' },
    ],
    scale: [
      { token: 'mega', size: '34px', use: 'the one number a panel exists for' },
      { token: 'quote', size: '22px', use: 'headline quote' },
      { token: 'kpi', size: '17px', use: 'panel statistics' },
      { token: 'cell', size: '12.5px', use: 'the workhorse — every grid body cell' },
      { token: 'label', size: '10.5px', use: 'column headers, uppercase, tracked' },
      { token: 'micro', size: '9.5px', use: 'axis ticks, provenance chips' },
    ],
    notes: [
      {
        title: 'Direction needs a reference',
        body: 'A number is only coloured when there is a defined thing it moved against. An absolute level is never green.',
      },
      {
        title: 'Attention is not approval',
        body: 'Gold means "this carries an asterisk". It never means good and never means up — that is why it also marks unbound panels.',
      },
      {
        title: 'Engine ink is reserved',
        body: 'One token carries everything the model says, and observed numbers are never drawn in it. Prediction versus fact becomes pre-attentive.',
      },
      {
        title: 'Stale loses colour',
        body: 'A green that is no longer true is worse than no colour at all, so muting overrides direction entirely.',
      },
      {
        title: 'Heat is not up/down',
        body: 'Correlation and z-score use a separate diverging ramp. A correlation of −0.9 is not "bad".',
      },
      {
        title: 'Contrast measured',
        body: 'Every text token meets AA against its own theme\u2019s panel background, checked with alpha compositing rather than assumed from hex values.',
      },
    ],
    inkRules: [
      {
        sample: '+1.24%',
        color: 'var(--wft-up)',
        label: 'up',
        body: 'A delta against a stated reference.',
      },
      {
        sample: '−0.86%',
        color: 'var(--wft-down)',
        label: 'down',
        body: 'Same rule, other direction.',
      },
      {
        sample: '0.00%',
        color: 'var(--wft-flat)',
        label: 'flat',
        body: 'Below displayed precision — not up.',
      },
      {
        sample: '—',
        color: 'var(--wft-ink-3)',
        label: 'no value',
        body: 'Never zero, never a dash pretending to be one.',
      },
      {
        sample: '1,284.06',
        color: 'var(--wft-ink-2)',
        label: 'stale',
        body: 'Colour withdrawn once the value ages out.',
      },
      {
        sample: '1,290.10',
        color: 'var(--wft-engine)',
        label: 'engine',
        body: 'A model number, in ink no fact may use.',
      },
    ],
    densities: [
      {
        name: 'compact',
        meta: '20px rows · 4px gutter',
        rows: [{ h: '20px' }, { h: '20px' }, { h: '20px' }, { h: '20px' }, { h: '20px' }],
      },
      {
        name: 'normal',
        meta: '24px rows · 6px gutter',
        rows: [{ h: '24px' }, { h: '24px' }, { h: '24px' }, { h: '24px' }],
      },
      {
        name: 'relaxed',
        meta: '30px rows · 44px targets',
        rows: [{ h: '30px' }, { h: '30px' }, { h: '30px' }],
      },
    ],
  };
}

export type DesignVals = ReturnType<typeof designVals>;
